export const attrKey2Label = {
  name: 'Unit',
  price: 'Price',
  rooms: 'Rooms',
  size_bra: 'Size_other',
  size_bta: 'Size_BTA',
  bathroom: 'Bathroom',
  bedroom: 'Bedroom',
  balcony: 'Balcony',
  owner_type: 'Owner_type',
  size_gross: 'Size',
  floor_external: 'Floor',
  floors_internal: 'Floor_internal',
  fee_monthly: 'Fee',
  size_prom: 'Size_prom',
  parking_space: 'Parking_space',
  monthly_rent: 'Monthly_rent',
  deposit: 'Deposit',
  shared_debt: 'Shared_debt',
  unit_other_string1: 'unit_other_string1',
  unit_other_string2: 'unit_other_string2',
  unit_other_int1: 'unit_other_int1',
  unit_other_int2: 'unit_other_int2',
  unit_other_dec1: 'unit_other_dec1',
  unit_other_dec2: 'unit_other_dec2',
  type_other_string1: 'type_other_string1',
  type_other_string2: 'type_other_string2',
  type_other_int1: 'type_other_int1',
  type_other_int2: 'type_other_int2',
  type_other_dec1: 'type_other_dec1',
  type_other_dec2: 'type_other_dec2',
};

export default {
  attrLabel: key => attrKey2Label[key],
};
